import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";

function PageLoader() {
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true); // Prikaži loader odmah kad se promeni ruta
        
        const timer = setTimeout(() => {
            setLoading(false); // Sakrij loader nakon 1 sekunde
        }, 1000);

        return () => clearTimeout(timer); // Očisti timer kada se komponenta demontira
    }, [location]);

    return loading ? <Loader /> : null;
}

export default PageLoader;
